var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.isFullPage,"color":"#0088CC"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }